import type { Editor } from '@meitu/saas-editor-core';
import { traverseTrees } from '@meitu/saas-editor-core/es/utils/tree-kit';
import type { ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import type { FontItem } from '@meitu/xdesign-widgets';

export function getUsingFonts(editor: Editor, stageIdx: number): FontItem[];
export function getUsingFonts(editor: Editor, layers: ILayerProps[]): FontItem[];
export function getUsingFonts(editor: Editor, param: number | ILayerProps[]): FontItem[] {
    const layers = Array.isArray(param) ? param : editor.services.frame.getLayers(param);
    const fontItems = new Map(editor.services.font.getFontItems().map((item) => [item.font_name, item]));
    const usingFonts = new Set<FontItem>();

    traverseTrees(layers, (layer: ILayerProps) => {
        const infos = editor.services.behavior.get(layer)?.getTextInfo?.(layer);
        if (!Array.isArray(infos)) return;

        for (const info of infos) {
            const fontItem = fontItems.get(info.fontFamily);
            if (fontItem) usingFonts.add(fontItem);
        }
    });

    return [...usingFonts];
}
